import { BillingCapabilitiesResponseDto, BillingCustomerResponseDto, EnterprisePlanDto, PartnerOrganizationSubscriptionResponseDto, PartnerOrganizationTrialResponseDto, PartnerOrganizationTrialSubscriptionConfigsResponseDto, SalesforceContractDto, } from '@lucidlink/dto/web-service-api';
import { parserFromDto } from '#fetcher';
// LUCID-34911: WebService versions before LUCID-33886 (https://bitbucket.org/lucidlink/lucid/pull-requests/16619/overview) return an empty body for extend-trial, plan and plan/amendments.
// Remove the null check once that WebService version is deployed everywhere (after Nov 2nd 2026)
const parseOptionalSubscriptionResponse = (json) => json === null
    ? undefined
    : PartnerOrganizationSubscriptionResponseDto.create(json);
export const createPartnerOrganizationBillingManager = ({ partnerOrganizationFetcher, }) => new PartnerOrganizationBillingManagerImpl(partnerOrganizationFetcher);
class PartnerOrganizationBillingManagerImpl {
    partnerOrganizationFetcher;
    billingFetcher;
    constructor(partnerOrganizationFetcher) {
        this.partnerOrganizationFetcher = partnerOrganizationFetcher;
        this.billingFetcher = this.partnerOrganizationFetcher.createSubFetcher({
            path: ['billing'],
        });
    }
    async getCapabilities(params) {
        return this.billingFetcher.get('/capabilities', {
            parser: parserFromDto(BillingCapabilitiesResponseDto),
            queryParams: { ...params },
        });
    }
    async getEnterprisePlan() {
        return this.partnerOrganizationFetcher.get('/plan', {
            parser: parserFromDto(EnterprisePlanDto),
        });
    }
    async startPartnerOrganizationEnterpriseTrial(startPartnerOrganizationEnterpriseTrialDto) {
        return this.partnerOrganizationFetcher.post(['trial'], {
            body: startPartnerOrganizationEnterpriseTrialDto,
            parser: parserFromDto(PartnerOrganizationTrialResponseDto),
        });
    }
    async extendPartnerOrganizationEnterpriseTrial(extendPartnerOrganizationTrialDto) {
        return this.partnerOrganizationFetcher.post(['extend-trial'], {
            body: extendPartnerOrganizationTrialDto,
            parser: parseOptionalSubscriptionResponse,
        });
    }
    async getTrialSubscriptionConfigs() {
        return this.partnerOrganizationFetcher.get(['trial-subscription-configs'], {
            parser: parserFromDto(PartnerOrganizationTrialSubscriptionConfigsResponseDto),
        });
    }
    async startPartnerOrganizationEnterprisePlan(startPartnerOrganizationEnterpriseDto) {
        return this.partnerOrganizationFetcher.post(['plan'], {
            body: startPartnerOrganizationEnterpriseDto,
            parser: parseOptionalSubscriptionResponse,
        });
    }
    async amendPartnerOrganizationEnterprisePlan(enterprisePlanAmendmentDto) {
        return this.partnerOrganizationFetcher.post(['plan/amendments'], {
            body: enterprisePlanAmendmentDto,
            parser: parseOptionalSubscriptionResponse,
        });
    }
    async getSalesforceContract(contractId) {
        return this.partnerOrganizationFetcher.get(['salesforce-contract', contractId], { parser: parserFromDto(SalesforceContractDto) });
    }
    async getBillingCustomer() {
        return this.billingFetcher.get('/customer', {
            parser: parserFromDto(BillingCustomerResponseDto),
        });
    }
}
